import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { map, mergeMap, tap } from 'rxjs/operators';
import { RestBookDao } from '../daos/book-dao';
import { Book } from '../model/models';
import { AwardService } from '../services/award.service';

@Component({
  selector: 'app-books',
  templateUrl: './books.component.html',
  styleUrls: ['./books.component.css']
})
export class BooksComponent implements OnInit {
  constructor(
    private awardService: AwardService,
    private bookDao: RestBookDao,
  ) { }

  books$: Observable<Book[]>;
  loading: boolean = true;
  error: boolean = false;

  ngOnInit(): void {
    this.loading = true;
    this.books$ = this.bookDao.getBooks().pipe(
      mergeMap(books => this.awardService.syncAwards(books)
        .pipe(
          map(books => books.sort((a, b) => this.smallerYear(a) - this.smallerYear(b))),
          map(books => books.map(book => {
            let currentYear;
            const awardWins = book.awardWins.map(win => {
              if (win.year !== currentYear) {
                currentYear = win.year;
                return { ...win };
              }
              else {
                return { award: win.award };
              }
            })
            return { ...book, awardWins } as Book;
          })),
          tap({
            next: () => {
              return this.loading = false;
            }
          }),
        )
      ));
  }

  bookIdToUpdate: number;

  updateBook(book: Book) {
    if (book.id == this.bookIdToUpdate) {
      book.isRead = !book.isRead;
      this.loading = true;
      this.bookDao.updateBook(book).subscribe({
        next: () => { this.loading = false; },
        error: () => { this.error = true; }
      });
      this.bookIdToUpdate = -1;
      return true;
    }
    else {
      this.bookIdToUpdate = book.id;
      setTimeout(() => {
        this.bookIdToUpdate = -1;
      }, 1000)
      return false;
    }
  }

  private smallerYear(book: Book): number {
    return book.awardWins.sort((c, d) => c.year - d.year)[0].year;
  }

}
